import React, { Component } from 'react';
import * as firebase from "firebase";
import { AsyncStorage } from "react-native";
import store from "../config/config.json"

const initialState = {
  offerData : undefined,
  orderData : undefined,
  itemData    : undefined,
  receiptData : undefined,
  onUpdate    : undefined,
  storyData : undefined,
  location : undefined,
  goBack : false,
  deliveryData : {area: "", timings : ""},
};

const AppContext = React.createContext();
export class AppProvider extends Component {
  
  constructor(props) {
    super(props);
    this.state = initialState;
    this.getDetails()
  }

  getDetails = async () => {		
		
    // Set the key-value pairs for the different languages you want to support.
    var that = this
    firebase.database().ref('stores/' + store.storeId).once("value", function(snapshot) {			

      let data = snapshot.val()
      if(data != undefined)
      {
        that.saveData(data)
      }

    }.bind(this), function(error) { 
      console.log(error)
    });
 }

 saveData = async data => {
   await AsyncStorage.setItem(store.storeData, JSON.stringify(data))
   this.setState({showLoading: false})
 };
 
  
  setUser = (user) => {
    this.setState({userData: user}); 
  }

  setReceipt = (receipt) => {
    this.setState({receiptData: receipt}); 
  }

  setDeliveryData = (receipt) => {
    //this.state.deliveryData = receipt
    this.setState({deliveryData: receipt}); 
  }

  setItem = (item) => {
    this.setState({itemData: item}); 
  }

  setOrder = (item) => {
    this.setState({orderData: item}); 
  }
    
  updateUser = () => {
    /*
    let uid = firebase.auth().currentUser.uid
    firebase.database().ref('users/' + uid).on("value", function(snapshot) {
        var personData = snapshot.val();
        this.setUser(personData);
     }.bind(this), function(error) { 

     });
     */
  }
  
  render() {
    return (
      <AppContext.Provider value={{
          receiptData: this.state.receiptData,
          color: this.state.color,
          goBack: this.state.goBack,
          location: this.state.location,
          setReceipt : this.setReceipt,

          setItem : this.setItem,
          itemData : this.state.itemData,

          setOrder : this.setOrder,
          orderData : this.state.orderData,

          storyData : this.state.storyData,
          onUpdate : this.state.onUpdate,

          setDeliveryData : this.setDeliveryData,
          deliveryData    : this.state.deliveryData
      }}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContext
